/* global Handlebars */

Handlebars.registerHelper('ifEquals', (arg1, arg2, options) => {
	return (arg1 === arg2) ? options.fn(this) : options.inverse(this);
});

Handlebars.registerHelper('ifVideoProduct', (arg1, options) => {
	var videoClasses = ['Thuis_College', 'Lezingen_Thuis'];
	return videoClasses.includes(arg1) ? options.fn(this) : options.inverse(this);
});

// Must be function instead of arrow expression.
Handlebars.registerHelper('ifNotEquals', function (arg1, arg2, options) {
	return (arg1 !== arg2) ? options.fn(this) : options.inverse(this);
});

Handlebars.registerHelper('ifTrue', (arg1, options) => {
	return (arg1) ? options.fn(this) : options.inverse(this);
});

Handlebars.registerHelper('ifFalse', (arg1, options) => {
	return (!arg1) ? options.fn(this) : options.inverse(this);
});

Handlebars.registerHelper('multiply', function(arg1, arg2) {
	return (parseFloat(arg1) * parseFloat(arg2)).toFixed(2);
});

Handlebars.registerHelper('multiplyWithFormat', function(arg1, arg2) {
	var multiplied = (parseFloat(arg1) * parseFloat(arg2)).toFixed(2);
	return new Intl.NumberFormat('nl-NL', {style: 'currency', currency: 'EUR'}).format(multiplied);
});


Handlebars.registerHelper('ifCond', function(v1, v2, options) {
	if (v1 === v2) {
		return options.fn(this);
	}
	return options.inverse(this);
});

Handlebars.registerHelper('sanitize',  function(str) {
  return str.replace(/(<([^>]+)>)/gi, "");
});

Handlebars.registerHelper('times', (n, block) => {
	var accum = '',
		i = -1;

	while (++i < n) {
		accum += block.fn(i);
	}

	return accum;
});

Handlebars.registerHelper('toLowerCase', function(str) {
	return str.toLowerCase();
});
